<template>
  <li>
    <router-link :to="{ name: 'graduates.single', params: { id: graduate.id }}">
      <div class="row">
        <div class="col-12 col-lg-7">
          <p class="text-truncate strong">{{ graduate.name }}</p>
          <ul class="details">
            <li>Username: {{ graduate.username }}</li>
            <li>Email: {{ graduate.email }}</li>
            <li>GEN: {{ graduate.gen }}</li>
          </ul>
        </div>

        <div class="col-3 col-lg-1 text-lg-center d-flex align-items-center justify-content-center">
          <p>
            <span class="data-label d-lg-none">Placement 1</span>
            <template v-if="firstPlacement && firstPlacement.manager_id">
              <font-awesome :icon="['fas', 'check']" class="text-success"/>
              <span class="sr-only">assigned</span>
            </template>
            <template v-else>
              <font-awesome :icon="['fas', 'times']" class="text-danger"/>
              <span class="sr-only">not assigned</span>
            </template>
          </p>
        </div>

        <div class="col-3 col-lg-1 text-lg-center d-flex align-items-center justify-content-center">
          <p>
            <span class="data-label d-lg-none">Placement 2</span>
            <template v-if="secondPlacement && secondPlacement.manager_id">
              <font-awesome :icon="['fas', 'check']" class="text-success"/>
              <span class="sr-only">assigned</span>
            </template>
            <template v-else>
              <font-awesome :icon="['fas', 'times']" class="text-danger"/>
              <span class="sr-only">not assigned</span>
            </template>
          </p>
        </div>

        <div class="col-3 col-lg-1 text-lg-center d-flex align-items-center justify-content-center">
          <p>
            <span class="data-label d-lg-none">Capability Data</span>
            <template v-if="graduate.initial_capabilities_set">
              <font-awesome :icon="['fas', 'check']" class="text-success"/>
              <span class="sr-only">assigned</span>
            </template>
            <template v-else>
              <font-awesome :icon="['fas', 'times']" class="text-danger"/>
              <span class="sr-only">not assigned</span>
            </template>
          </p>
        </div>

        <div class="col-3 col-lg-1 text-lg-center d-flex align-items-center justify-content-center">
          <p>
            <span class="data-label d-lg-none">Account</span>
            <template v-if="graduate.enabled">
              <font-awesome :icon="['fas', 'check']" class="text-success"/>
              <span class="sr-only">activated</span>
            </template>
            <template v-else>
              <font-awesome :icon="['fas', 'times']" class="text-danger"/>
              <span class="sr-only">not activated</span>
            </template>
          </p>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/graduates'

export default {
  mixins: [helpers],

  props: {
    graduate: {
      required: true,
      type: Object
    }
  }
}
</script>
